/**
 * Main Application Entry Point
 */

import { initializeStats } from './modules/stats';
import { initializeMap } from './modules/map';
import { initializePeeringDB } from './modules/peeringdb';

// Import Leaflet CSS
import 'leaflet/dist/leaflet.css';

// Import Leaflet for icon fix
import L from 'leaflet';

// Fix Leaflet default icon paths for bundlers
// Leaflet's default icons break with Vite because asset paths change
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Remove the default icon URL getter
delete (L.Icon.Default.prototype as any)._getIconUrl;

// Set the correct icon paths
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

/**
 * Main application initialization function
 */
async function initializeApp(): Promise<void> {
  try {
    // Initialize all modules in parallel
    await Promise.all([
      initializeStats(),
      initializeMap(),
      initializePeeringDB()
    ]);

    console.log('Application initialized successfully');
  } catch (error) {
    console.error('Application initialization error:', error);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeApp();
  });
} else {
  // DOM already loaded
  initializeApp();
}
